import * as React from 'react'

import { Search } from 'lucide-react'

import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
} from '~/client/src/shared/components/shadcn-ui/input-group'
import Localization from '~/client/src/shared/localization/LocalizationManager'

interface IProps {
  value: string
  onChange: (next: string) => void
  placeholder?: string
  autoFocus?: boolean
}

const OptionsSearch: React.FC<IProps> = ({
  value,
  onChange,
  placeholder,
  autoFocus,
}) => {
  return (
    <div data-slot="options-search" className="tw:flex-1 tw:min-w-0">
      <InputGroup>
        <InputGroupAddon>
          <Search aria-hidden="true" />
        </InputGroupAddon>
        <InputGroupInput
          value={value}
          autoFocus={autoFocus}
          placeholder={placeholder ?? Localization.translator.search}
          onChange={e => onChange(e.target.value)}
        />
      </InputGroup>
    </div>
  )
}

export default OptionsSearch
